import { normalizeLocale } from '../../utils/helpers/constants.helpers';

export const preferedLanguage = (language) => {
  if (language) {
    return normalizeLocale(language);
  }

  if (typeof window === 'undefined') {
    return 'en';
  }

  return normalizeLocale(window.localStorage.getItem('i18nextLng'));
};
